import React, { useCallback, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import { Link } from "react-router-dom";

import { loadTemplateFile } from '../tools/layout-tool';
import { useAuth } from "../use-auth"

import { promiseFetchDataAuth } from 'crk-front-lib';
// eslint-disable-next-line no-unused-vars
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { ZetaGroup, ZetaSection } from "../zeta-widget";
import { useZetaStateChange } from "../zeta-widget/tools/handle-tool";
import { ActionBar } from "../zeta-widget/widgets/action-bar";

export function OrganizeInfo(props) {
  const auth = useAuth();
  // const [lang, setLang] = useState(auth.lang || 'en');
  const [appTemplate, setAppTemplate] = useState([]);
  const [orgProfile, setOrgProfile] = useState({});

  useEffect(() => {
    loadTemplateFile('org-info', (result) => {
      setAppTemplate(result);
    })
  },[]);

  useEffect(() => {
    const url = `${auth.config.storeApi}/api/v2/org/pkg/${auth.user.pkg_id}`
    promiseFetchDataAuth(url)
    .then(result => {
      setOrgProfile({...result});
    })
    .catch((err) => {
      console.warn(err);
    })
  }, [auth.config.storeApi, auth.user.pkg_id])

  const handleChange = useZetaStateChange(orgProfile, setOrgProfile);
  const handleSave = useCallback(() => {
    // console.info(auth);
    
    const url = `${auth.config.storeApi}/api/v2/org/${auth.user.org_id}`;

    promiseFetchDataAuth(url, 'PUT', orgProfile)
    .then(result => {
      // setOrgProfile({...result});
      showAlert('Save Success', 'success');
    })
    .catch((err) => {
      console.warn(err);
    })
    
  }, [auth.config.storeApi, auth.user.org_id, orgProfile])

  const _this = {
    auth,
    lang: auth.lang || 'en',
    locale: auth.lang === 'th'? 'th-TH': 'en-UK',

    // handlers,
  };

  return (
    <ZetaSection title="ข้อมูลบริษัท" name="entry" app={_this}>
      <form>
        <ZetaGroup template={appTemplate} size="medium" data={orgProfile} /*app={_this}*/ onChange={handleChange} />
      </form>
      <ActionBar className={auth.user.member_role==='OWNER' ? '' : 'd-none'}>
        <button type="button" 
          className="btn btn-sm mx-1 btn-success"
          onClick={handleSave}>บันทึก</button>
      </ActionBar>
    </ZetaSection>
  )
}